import { parse } from 'date-fns';
import { useState } from 'react';
/**
 * NOTE: this is a temporary fix. This behavior should be moved to the Datepicker component in the CL
 */
var validDateFormat = function (testDate) {
    var dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    return dateRegex.test(testDate);
};
var useCalendarBlur = function (handleChange) {
    var _a = useState(true), shouldBlur = _a[0], setBlur = _a[1];
    var handleBlur = function (date) {
        if (shouldBlur) {
            try {
                if (!validDateFormat(date)) {
                    handleChange(new Date('Invalid Date'));
                }
                else {
                    // if this function returns successfully then it's a valid date
                    handleChange(parse(date, 'MM/dd/yyyy', new Date()));
                }
            }
            catch (e) {
                handleChange(new Date('Invalid Date'));
            }
        }
    };
    var handleMouseEnter = function () { return setBlur(false); };
    var handleMouseLeave = function () { return setBlur(true); };
    return {
        handleBlur: handleBlur,
        handleMouseEnter: handleMouseEnter,
        handleMouseLeave: handleMouseLeave
    };
};
export default useCalendarBlur;
//# sourceMappingURL=useCalendarBlur.js.map